import React from 'react'
import './Similar_product_card.css'
import { Link } from 'react-router-dom'

const Similar_product_card = (props) => {
    return (
        <>
            <section className='Similar_product_card'>
                <Link to={props.link}>
                    <div className='img_div'>
                        <img className='productimg' src={props.image} alt="productimg" />
                    </div>
                    <div className='contentdiv'>
                        <p className='prodname'>{props.name}</p>
                        <p className='subname'>{props.subname}</p>
                        <p className='prise'>₹{props.prise}</p>
                        <p className='oldprice'>₹{props.oldprise}</p>
                    </div>
                </Link>
            </section>
        </>
    )
}

export default Similar_product_card